import { AxiosResponse, AxiosError } from "axios";
import { prepareError } from "../../../utils/error";
import api from "../../../data/api";
import { OptionCl } from "../../../components/select-cl";
import { Dispatch } from "redux";
//import { Currency } from "../../../openapi/currency/api"

export const CURRENCY_DOMAIN = "CURRENCY"
export const CURRENCYSHORT_DOMAIN = "CURRENCYSHORT"

export type Currency = {    
    curr: string,
    currnm:string
}

const prepareCurrenciesIdDesc  = ( response : Currency[]   ) => {
    const opts: OptionCl[] = response.map( (curr : Currency) => ({
        id : curr.curr ||"" ,
        description: curr.curr + " - " + curr.currnm
    })
    )
    return opts;
}


const prepareCurrenciesDesc  = ( response : Currency[]   ) => {
    const opts: OptionCl[] = response.map( (curr : Currency) => ({
        id : curr.currnm || "",
        description: curr.currnm || ""
    })
    )
    return opts;
}

// currencies for the dropdown
export const fetchCurrencies = (
    dispatch : Dispatch<any>,
    componentType: "CcbCriteria" 
) => {
    //console.log("ismag criteria service getting data from /cities")
    api
        .post("/codelist/v1/ccb/currencies")
        .then( (response:AxiosResponse) => {

            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                //console.log("currency domain service: got data " + JSON.stringify(response))
                const currencies : Currency[] = response.data.CCB; 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareCurrenciesIdDesc(currencies), domain: CURRENCY_DOMAIN })                
            }
        }).catch( (error:AxiosError) => {
            console.log("getting currencies but got error " + error.message)
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}


export const fetchCurrencyNames = (
    dispatch : Dispatch<any>,
    componentType: "CcbCriteria" 
) => {
    //console.log("ismag criteria service getting data from /cities")
    api
        .post("/codelist/v1/ccb/currNames")
        .then( (response:AxiosResponse) => {

            if (response.data && response.data.result === "ERROR") {
                dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(response.data) })
            } else { 
                //console.log("currency domain service: got data " + JSON.stringify(response))
                const currencies : Currency[] = response.data.CCB;                 
                dispatch({type: componentType + "/DOMAINLOADED", payload: prepareCurrenciesDesc(currencies), domain: CURRENCYSHORT_DOMAIN })
            }
        }).catch( (error:AxiosError) => {
            console.log("getting currencies but got error " + error.message)
            dispatch({ type: componentType + "/FETCHERROR", payload: prepareError(error) })
        })

}
